<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
        <a class="navbar-brand" href="">
            <img src="./assets/img/franja.svg" width="60" height="30" alt="">
        </a>
        <div class="collapse navbar-collapse" id="navbarNavDarkDropdown" *ngIf="cantEmpresaRep > 0">
            <ul class="navbar-nav">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="navbarDarkDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <fa-icon [icon]="['fas', 'bars']" size="lg"></fa-icon>
                </a>
                <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbar1DarkDropdownMenuLink">
                    <li *ngFor="let item of menuItems"><a class="dropdown-item" [routerLink]="item.destination">{{ item.description }}</a></li>
                </ul>
            </li>
            </ul>
        </div>
        <div class="card-column ms-3 me-4" >
            <!--<div class="btn-group me-3" *ngIf="cantEmpresaRep > 0">
                <button type="button" class="btn btn-light" disabled>{{ listaEmprService.rznSocialEmprSel }}</button>
                <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" id="dropdownMenuReference" data-bs-toggle="dropdown" aria-expanded="false" data-bs-reference="parent">
                  <span class="visually-hidden">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuReference">
                    <li *ngFor="let empresa of listaEmprService.grupoEmpresas">
                        <a class="dropdown-item" (click)="seleccionarEmpresa(empresa.RUT_EMPRESA)">{{ empresa.RAZON_SOCIAL }}</a>
                    </li>
                </ul>
            </div>-->
            <button class="btn btn-outline-light" (click)="cerrar();" type="submit"><fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon> Cerrar Sesión</button>
        </div>
    </div>
</nav>